import React from 'react';
import * as _ from 'lodash';
import Kendra from 'aws-sdk/clients/kendra';
import { Header, Link } from '@cloudscape-design/components';
import { useNavGraph } from 'src/components/providers/NavGraphProvider';
import { findInNavGraph } from 'src/utils/findInNavGraph';

interface ResultTitleProps {
    queryResultItem: Kendra.QueryResultItem;
    attributes: any;
    topicUrl: string;
    documentTitle: string;
    documentId: string;
}

const getStringFromDocAttributes = (
    attributes: Record<string, any>,
    key: string
): string | undefined => attributes[key]?.StringValue;

export const ResultTitle = ({
    queryResultItem,
    attributes,
    topicUrl,
    documentTitle,
    documentId,
}: ResultTitleProps) => {
    const { navGraph } = useNavGraph();

    const getImageUrl = (id: string, path: string | undefined) => {
        if (!path) return '';
        const document = findInNavGraph(parseInt(id), path, navGraph, 'id');
        return document?.pictureUrl || '';
    };

    const breadcrumbPath = getStringFromDocAttributes(
        attributes,
        'breadcrumbPath'
    );
    const imageUrl = getImageUrl(documentId, breadcrumbPath);

    let title: string;
    if (
        queryResultItem.DocumentTitle &&
        !_.isEmpty(queryResultItem.DocumentTitle.Text)
    ) {
        title = `${documentTitle} > ${queryResultItem.DocumentTitle.Text}`;
    } else {
        title = documentTitle;
    }

    const resultTitle = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {imageUrl && (
                <img
                    alt=""
                    src={imageUrl}
                    style={{
                        width: '50px',
                        marginRight: '20px',
                    }}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            )}
            <Link href={topicUrl}>{title}</Link>
        </div>
    );

    return <Header variant="h3">{resultTitle}</Header>;
};
